import * as React from 'react';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { Link, useHistory } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { useHorsesStore } from '../../../stores/horses'
import dayjs from 'dayjs';
import { Observer, observer } from 'mobx-react';
import CircularProgress from '@mui/material/CircularProgress';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Box, DialogContent, FormControl, InputLabel, MenuItem, Skeleton } from '@mui/material';
export interface DialogProps {
    open: boolean;
    onClose: () => void;
    onSelect: (orderId: number) => void;
    profileId?: string;
}
const App: React.FC<DialogProps> = (props) => {
    const { onClose, open } = props;
    const route = useHistory()
    const store = useHorsesStore()
    const handleClose = () => {
        onClose();
    };

    const handleListItemClick = async (value: typeof store.orders[number]) => {
        await store.setSelectedOrderId(value.parent_order_id, props.profileId)
        await store.list()
        props.onSelect(value.parent_order_id)
        onClose();
    };

    React.useEffect(() => {
        if (open == true) {
            store.usrId && store.getAvailableHosres(store.usrId)
        }
        console.log(store.orders.length)
    }, [open])


    return (
        <Observer>{() =>
            <Dialog onClose={handleClose} open={open}>
                {store.orderLoading == true ? <>
                    <DialogTitle><Skeleton variant="text" height={30} width={220} /></DialogTitle>
                    <DialogContent><Skeleton variant="rounded" height={80} width={220} /></DialogContent>

                </> : <>
                    <DialogTitle>To add a horse in EquiManage please choose from one of the following available plans:</DialogTitle>
                    <DialogContent>
                        <List sx={{ pt: 0 }} >
                            {store.orders.length > 0 ? <>{store.orders.map((order) => (
                                order.available != undefined && order.available < order.quantity && Number(order.expiry_date) * 1000 > Date.now() ?
                                    <ListItem disableGutters sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <ListItemButton onClick={() => handleListItemClick(order)} key={order.parent_order_id}>
                                            <ListItemAvatar>
                                                <Avatar sx={{ bgcolor: blue[100], color: '#408697' }}>
                                                    <BookmarkBorderIcon />
                                                </Avatar>
                                            </ListItemAvatar>

                                            <ListItemText
                                                primary={
                                                    <Typography variant='h6'>Active Equimanage plan:
                                                        {/* <Typography display={'inline-block'} variant='h6'>{dayjs(Number(order.expiry_date) * 1000).format('DD/MM/YYYY') as string}.</Typography> */}
                                                    </Typography>
                                                }
                                                secondary={
                                                    <Typography variant='h6'>{`You've used `}
                                                        <Typography display={'inline-block'} variant='h4' color={'#408697'}>{order.available}/{order.quantity}</Typography>
                                                    </Typography>
                                                }

                                            />
                                        </ListItemButton>

                                    </ListItem> : null

                            ))} <ListItem disableGutters >
                                    <Typography sx={{ ml: 2, mr: 2 }} variant='body1'>You've run out or EquiManage allocation, please purchase a new plan: </Typography>
                                    <SelectOrder />
                                </ListItem>
                            </> :
                                <ListItem disableGutters>

                                    <a href={'https://equimatch.co.nz/checkout/?coupon=5FREEHORSEPROFILES&pid=20498&qty=5'} target="_blank">
                                        <Typography sx={{ ml: 2, mr: 2 }} variant='h4' color={'#408697'}>Click and Get 5 Free Horse Profiles!</Typography>
                                    </a>
                                </ListItem>}
                        </List>

                    </DialogContent></>}


            </Dialog>


        }</Observer>
    );
}


const plans = [
    'https://equimatch.co.nz/checkout/?add-to-cart=20498&quantity=1',
    'https://equimatch.co.nz/checkout/?add-to-cart=20498&quantity=5',
    'https://equimatch.co.nz/checkout/?add-to-cart=20498&quantity=10',
    'https://equimatch.co.nz/checkout/?add-to-cart=20498&quantity=20'
]
function SelectOrder() {
    const [order, setOrder] = React.useState('');

    const handleChange = (event: SelectChangeEvent) => {
        setOrder(event.target.value as string);
        window.location.replace(event.target.value);
    };

    return (
        <Box sx={{ minWidth: 60, mt: '-16px' }}>
            <FormControl variant="standard" size='small'>
                <InputLabel id="demo-simple-select-standard-label">Plan</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={order}
                    label="Plan"
                    onChange={handleChange}
                >
                    <MenuItem value={plans[0]}>1 extra horse profile - $10</MenuItem>
                    <MenuItem value={plans[1]}>5 extra horse profiles - 25% discount</MenuItem>
                    <MenuItem value={plans[2]}>10 extra horse profiles - 33.3% discount</MenuItem>
                    <MenuItem value={plans[3]}>20 extra horse profiles - 50% discount</MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
}
export default observer(App)
